import { useHistory } from "react-router-dom";
import { Button } from "@mantine/core";

import { useUrlSearch } from "@hooks";

import { AddProjectsDialog, DialogState } from "./AddProjectsDialog";

export function AddProjectsButton({ title }: { title?: string }) {
  const history = useHistory();
  const { search } = useUrlSearch();

  function setOpenDialog(newModalState: DialogState) {
    search.set("select-ci", newModalState);
    history.push({
      search: search.toString(),
    });
  }

  return (
    <>
      <AddProjectsDialog />
      <Button
        color="violet"
        onClick={() => {
          setOpenDialog("new-project");
        }}
      >
        {title ?? "Add projects"}
      </Button>
    </>
  );
}
